(function ($)
{
    $.widget("ui.SearchPagination",
    {
        options:
        {
            NavigationUrl: null,
            OnChange: null,
            OnSuccess: null,
            OnError: null,
            InitialPagerData: null,
            RequestDataFunc: null,
            LiveRegionId: null,
            SearchDataReferenceType: null,
            PagerButtonClass: 'pager_button',
            PageContainerClass: 'pager_pages',
            PageButtonClass: 'page_button',
            ContentContainerSelector: '.pager_content'
        },

        _destroy: function ()
        {
        },

        _init: function ()
        {
        },

        _create: function ()
        {
            var self = this;
            var jElement = $(self.element);

            if (self.options.NavigationUrl === null
                || self.options.OnChange === null
                || self.options.OnSuccess === null
                || self.options.OnError === null
                || FBUtilities.IsParameterUndefinedOrEmpty(self.options.PagerButtonClass)
                || FBUtilities.IsParameterUndefinedOrEmpty(self.options.PageContainerClass)
                || FBUtilities.IsParameterUndefinedOrEmpty(self.options.PageButtonClass)
                || FBUtilities.IsParameterUndefinedOrEmpty(self.options.ContentContainerSelector))
            {
                return;
            }
            
            if (self.options.InitialPagerData !== null)
            {
                self._updatePagerMarkup(self.options.InitialPagerData);
            }
            
            self._updateButtons(null);
            
            // change to ON listener.
            jElement.on(
                'click',
                function(aEvent)
                {
                    var lButton = $(aEvent.target).closest('.' + self.options.PagerButtonClass );
                    if (lButton.length === 0)
                    {
                        return false;
                    }
                    if (lButton.hasClass('disable_button'))
                    {
                        return false;
                    }
                    var lTargetPage = lButton.data('fbpager-page');
                    if (!FBUtilities.IsParameterUndefinedOrNull(lTargetPage))
                    {
                        self.ChangePage(lTargetPage);
                        return false;
                    }
                    return false;
                }
            );
            
            if (!FBUtilities.IsParameterUndefinedOrNull(self.options.LiveRegionId))
            {
                jElement.find('.' + self.options.PagerButtonClass).attr('aria-controls', self.options.LiveRegionId);
            }
        },
        
        _updatePagerMarkup: function(aPagerData)
        {
            var self = this;
            var jElement = $(self.element);
           
            var lPagesContainer = jElement.find('.' + self.options.PageContainerClass);
            if (lPagesContainer.length === 0)
            {
                return;
            }
            lPagesContainer.html('');
            jElement.data('fbpager-totalpages', '');
            jElement.data('fbpager-currentpage', '');
            
            if (aPagerData === null)
            {
                jElement.hide();
                return;
            }
            else
            {
                jElement.show();
            }
            
            var lTotalPages = aPagerData['total_pages'];
            var lCurrentPage = aPagerData['current_page'];
            var lFirstPage = aPagerData['pager_first_page'];
            var lLastPage = aPagerData['pager_last_page'];
            
            if (lTotalPages <= 1)
            {
                jElement.find('.' + self.options.PageButtonClass).hide();
                lPagesContainer.hide();
            }
            
            var lAriaControls = '';
            if (!FBUtilities.IsParameterUndefinedOrNull(self.options.LiveRegionId))
            {
                lAriaControls = ' aria-controls="' + self.options.LiveRegionId + '"';
            }
            
            var lNewHtml = '';
            for(var lIndex = Number(lFirstPage); lIndex <= Number(lLastPage); lIndex += 1)
            {
                lNewHtml += '<a href="#" class="' + self.options.PagerButtonClass + ' ' + self.options.PageButtonClass + '" data-fbpager-page="' + lIndex + '"' + lAriaControls + '><span class="screen-reader-text">Page</span> ' + lIndex + '</a>\n';
            }//endfor
            jElement.children('.' + self.options.PagerButtonClass + '.page_last').data('fbpager-page', lTotalPages);
            
            lPagesContainer.html(lNewHtml);
            jElement.data('fbpager-totalpages', lTotalPages);
            jElement.data('fbpager-currentpage', lCurrentPage);
        },
        
        ///////////////////////////////////////////////////////////////////////////////
        /// ChangePage: function (aPageNumber)
        /// aPageNumber - the desired page number.
        /// aCallbacks - a set of one-time callbacks for this page change (optional).
        ChangePage: function (aPageNumber, aCallbacks)
        {
            var self = this;
            var jElement = $(self.element);
            self.options.OnChange();

            var lPageNumber = $.isNumeric(aPageNumber) ? aPageNumber : 1;
            var lData = {
                'PageNumber': lPageNumber,
                'SearchDataReferenceType': self.options.SearchDataReferenceType,
                'rndm': Math.random()
            };
            
            if (self.options.RequestDataFunc !== null)
            {
                var lFuncData = self.options.RequestDataFunc();
                lData = $.extend( lData, lFuncData );
            }

            $.ajax(self.options.NavigationUrl, 
            {
                success: function (aData, aTextStatus, aJqXHR)
                {
                    self.options.OnSuccess(aData, aTextStatus, aJqXHR);
                    var lPagerData = aJqXHR.getResponseHeader('pager_data');
                    var lPagerObject = eval("(" + lPagerData + ")");
                    self._updatePagerMarkup(lPagerObject);
                    self._updateButtons(aPageNumber);
                    FBUtilities.RunCallback(aCallbacks, 'OnSuccess');
                },
                error: function (aJqXHR, aTextStatus, aErrorThrown)
                {
                    self.options.OnError(aJqXHR, aTextStatus, aErrorThrown);
                    FBUtilities.RunCallback(aCallbacks, 'OnError');
                },
                complete: function (aJqXHR, aTextStatus)
                {
                    FBUtilities.RunCallback(aCallbacks, 'OnComplete');
                },
                data: lData,
                type: 'POST'
            });
        },

        NextPage: function (aLoopOnEnd, aCallbacks)
        {
            var self = this;
            var jElement = $(self.element);

            self._stepPage(true, aLoopOnEnd, aCallbacks);
        },
        
        PrevPage: function (aLoopOnEnd, aCallbacks)
        {
            var self = this;
            var jElement = $(self.element);

            self._stepPage(false, aLoopOnEnd, aCallbacks);
        },
        
        _stepPage: function (aForward, aLoopOnEnd, aCallbacks)
        {
            var self = this;
            var jElement = $(self.element);

            var lTotalPages = FBUtilities.GetIntOrNull(jElement.data('fbpager-totalpages'));
            var lCurrentPage = FBUtilities.GetIntOrNull(jElement.data('fbpager-currentpage'));
            var lNewPage = null;
            
            if (lTotalPages === null
                || lCurrentPage === null)
            {
                return;
            }
            
            if (aForward)
            {
                if (lCurrentPage === lTotalPages)
                {
                    if (aLoopOnEnd === false)
                    {
                        return;
                    }
                    lNewPage = 1;
                }
                else
                {
                    lNewPage = lCurrentPage + 1;
                }
            }
            else
            {
                if (lCurrentPage === 1)
                {
                    if (aLoopOnEnd === false)
                    {
                        return;
                    }
                    lNewPage = lTotalPages;
                }
                else
                {
                    lNewPage = lCurrentPage - 1;
                }
            }
            self.ChangePage(lNewPage, aCallbacks);
        },
        
        _updateButtons: function(aCurrentPage)
        {
            var self = this;
            var jElement = $(self.element);

            var lPaginationButtons = jElement.find('.' + self.options.PagerButtonClass);
            
            var lPagesContainer = jElement.find('.' + self.options.PageContainerClass);
            if (lPagesContainer.length === 0)
            {
                return;
            }
            
            var lTotalPages = parseInt(jElement.data('fbpager-totalpages'));
            var lCurrentPage = parseInt(aCurrentPage);
            
            if (isNaN(lCurrentPage))
            {
                lCurrentPage = jElement.data('fbpager-currentpage');
            }
            else
            {
                jElement.data('fbpager-currentpage', lCurrentPage);
            }
            
            if (lPaginationButtons.length === 0)
            {
                return;
            }
            
            if (lTotalPages <= 1)
            {
                jElement.find('.' + self.options.PageButtonClass).hide();
                lPagesContainer.hide();
                jElement.hide();
            }
            else
            {
                jElement.find('.' + self.options.PageButtonClass).show();
                lPagesContainer.show();
                jElement.show();
            }
            
            var lPrevButton = jElement.find('.page_prev');
            var lNextButton = jElement.find('.page_next');
            
            if (lPrevButton.length !== 0)
            {
                lPrevButton.data('fbpager-page', lCurrentPage - 1);
            }
            if (lNextButton.length !== 0)
            {
                lNextButton.data('fbpager-page', lCurrentPage + 1);
            }
            
            lPaginationButtons.removeClass('disable_button');
            lPaginationButtons.removeClass('pager_page_active');
            
            $.each(
                lPaginationButtons,
                function(aIndex, aValue)
                {
                    var jValue = $(aValue);
                    
                    var lTargetPage = Number(jValue.data('fbpager-page'));
                    var lIsSpecificPageButton = jValue.hasClass(self.options.PageButtonClass);
                    
                    if (lTargetPage < 1
                        || lTargetPage > lTotalPages
                        || lTargetPage == lCurrentPage)
                    {
                        jValue.addClass('disable_button');
                    }
                    if (lTargetPage == lCurrentPage
                        && lIsSpecificPageButton === true)
                    {
                        jValue.addClass('pager_page_active');
                    }
                }
            );
        }
        
    });
})(jQuery);
